export default "__VITE_ASSET__D$uP0rOS__"